import React, { useState, useEffect } from 'react';
import { useI18n } from '../../i18n/I18nContext';
import api from '../../utils/api';

function VendorOffers() {
  var i18n = useI18n();
  var t = i18n.t;

  var loadingState = useState(true);
  var loading = loadingState[0];
  var setLoading = loadingState[1];

  var offersState = useState([]);
  var offers = offersState[0];
  var setOffers = offersState[1];

  var editingState = useState(null);
  var editingTranslation = editingState[0];
  var setEditingTranslation = editingState[1];

  var editTextState = useState('');
  var editText = editTextState[0];
  var setEditText = editTextState[1];

  useEffect(function() {
    loadOffers();
  }, []);

  function loadOffers() {
    api.get('/vendor/offers')
      .then(function(data) {
        setOffers(data);
        setLoading(false);
      })
      .catch(function(err) {
        console.error('Failed to load offers:', err);
        setLoading(false);
      });
  }

  function getQABadgeStyle(score) {
    if (score >= 85) return { background: '#d4edda', color: '#155724' };
    if (score >= 70) return { background: '#fff3cd', color: '#856404' };
    return { background: '#f8d7da', color: '#721c24' };
  }

  function openEditModal(offerId, translationType, currentText, translationId) {
    setEditingTranslation({ offerId: offerId, type: translationType, translationId: translationId });
    setEditText(currentText || '');
  }

  function closeEditModal() {
    setEditingTranslation(null);
    setEditText('');
  }

  function saveTranslation() {
    if (!editingTranslation) return;

    api.put('/vendor/offers/' + editingTranslation.offerId + '/translations/' + editingTranslation.translationId, {
      translated_text: editText,
      edit_reason: 'Manual correction by vendor'
    })
      .then(function() {
        closeEditModal();
        loadOffers();
      })
      .catch(function(err) {
        alert('Failed to save: ' + err.message);
      });
  }

  if (loading) {
    return React.createElement('div', { className: 'flex justify-center', style: { padding: '40px' } },
      React.createElement('div', { className: 'spinner' })
    );
  }

  return React.createElement('div', null,
    React.createElement('h1', { style: { fontSize: '24px', fontWeight: '600', marginBottom: '24px' } }, 
      t('vendor.myOffers') || 'My Offers'
    ),

    offers.length === 0 
      ? React.createElement('div', { className: 'card text-center text-secondary' }, 'No offers found')
      : offers.map(function(offer) {
          var titleTrans = offer.translations && offer.translations['offer_title'];
          var descTrans = offer.translations && offer.translations['offer_short_description'];

          return React.createElement('div', { key: offer.id, className: 'card', style: { marginBottom: '16px' } },
            // Offer header
            React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' } },
              React.createElement('div', null,
                React.createElement('span', { 
                  className: 'badge',
                  style: { background: 'var(--primary)', color: 'white', marginRight: '8px' }
                }, offer.category_name),
                offer.active 
                  ? React.createElement('span', { className: 'badge badge-success' }, 'Active')
                  : React.createElement('span', { className: 'badge badge-secondary' }, 'Inactive')
              )
            ),

            // Title with translation
            React.createElement('div', { style: { marginBottom: '16px' } },
              React.createElement('label', { className: 'form-label', style: { fontSize: '12px', textTransform: 'uppercase', color: 'var(--text-secondary)' } }, 'Title'),
              React.createElement('div', { style: { background: 'var(--background)', padding: '12px', borderRadius: 'var(--radius)' } },
                React.createElement('div', { style: { marginBottom: '8px' } },
                  React.createElement('span', { style: { fontWeight: '500', marginRight: '8px', color: 'var(--text-secondary)', fontSize: '12px' } }, '[EN]'),
                  React.createElement('span', { style: { fontWeight: '600' } }, offer.title)
                ),
                titleTrans && React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
                  React.createElement('div', null,
                    React.createElement('span', { style: { fontWeight: '500', marginRight: '8px', color: 'var(--text-secondary)', fontSize: '12px' } }, '[TH]'),
                    React.createElement('span', null, titleTrans.text)
                  ),
                  React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: '8px' } },
                    titleTrans.qa_score && React.createElement('span', {
                      style: Object.assign({}, getQABadgeStyle(titleTrans.qa_score), { padding: '2px 8px', borderRadius: '4px', fontSize: '12px' })
                    }, titleTrans.qa_score + '%'),
                    React.createElement('button', {
                      className: 'btn btn-secondary',
                      style: { padding: '4px 8px', fontSize: '12px' },
                      onClick: function() { 
                        api.get('/vendor/offers/' + offer.id + '/translations')
                          .then(function(trans) {
                            var t = trans.find(function(x) { return x.entity_type === 'offer_title'; });
                            if (t) openEditModal(offer.id, 'title', t.translated_text, t.id);
                          });
                      }
                    }, t('common.edit'))
                  )
                ),
                titleTrans && titleTrans.qa_score && titleTrans.qa_score < 85 && React.createElement('div', {
                  style: { marginTop: '8px', fontSize: '12px', color: '#856404' }
                }, t('translation.needsReview'))
              )
            ),

            // Description with translation
            offer.short_description && React.createElement('div', { style: { marginBottom: '16px' } },
              React.createElement('label', { className: 'form-label', style: { fontSize: '12px', textTransform: 'uppercase', color: 'var(--text-secondary)' } }, 'Description'),
              React.createElement('div', { style: { background: 'var(--background)', padding: '12px', borderRadius: 'var(--radius)' } },
                React.createElement('div', { style: { marginBottom: '8px' } },
                  React.createElement('span', { style: { fontWeight: '500', marginRight: '8px', color: 'var(--text-secondary)', fontSize: '12px' } }, '[EN]'),
                  React.createElement('span', null, offer.short_description)
                ),
                descTrans && React.createElement('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
                  React.createElement('div', null,
                    React.createElement('span', { style: { fontWeight: '500', marginRight: '8px', color: 'var(--text-secondary)', fontSize: '12px' } }, '[TH]'),
                    React.createElement('span', null, descTrans.text)
                  ),
                  React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: '8px' } },
                    descTrans.qa_score && React.createElement('span', {
                      style: Object.assign({}, getQABadgeStyle(descTrans.qa_score), { padding: '2px 8px', borderRadius: '4px', fontSize: '12px' })
                    }, descTrans.qa_score + '%'),
                    React.createElement('button', {
                      className: 'btn btn-secondary',
                      style: { padding: '4px 8px', fontSize: '12px' },
                      onClick: function() { 
                        api.get('/vendor/offers/' + offer.id + '/translations')
                          .then(function(trans) {
                            var t = trans.find(function(x) { return x.entity_type === 'offer_short_description'; });
                            if (t) openEditModal(offer.id, 'description', t.translated_text, t.id);
                          });
                      }
                    }, t('common.edit'))
                  )
                ),
                descTrans && descTrans.qa_score && descTrans.qa_score < 85 && React.createElement('div', {
                  style: { marginTop: '8px', fontSize: '12px', color: '#856404' }
                }, t('translation.needsReview'))
              )
            )
          );
        }),

    // Edit Modal
    editingTranslation && React.createElement('div', {
      style: {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000
      },
      onClick: closeEditModal
    },
      React.createElement('div', {
        className: 'card',
        style: { width: '90%', maxWidth: '500px', maxHeight: '80vh', overflow: 'auto' },
        onClick: function(e) { e.stopPropagation(); }
      },
        React.createElement('h3', { style: { marginBottom: '16px' } }, t('translation.editTranslation')),
        React.createElement('textarea', {
          className: 'form-control',
          rows: 4,
          value: editText,
          onChange: function(e) { setEditText(e.target.value); },
          style: { marginBottom: '16px' }
        }),
        React.createElement('div', { style: { fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '16px' } },
          '⚠️ Your edit will be logged and an admin may review it.'
        ),
        React.createElement('div', { style: { display: 'flex', gap: '8px', justifyContent: 'flex-end' } },
          React.createElement('button', { className: 'btn btn-secondary', onClick: closeEditModal }, 'Cancel'),
          React.createElement('button', { className: 'btn btn-primary', onClick: saveTranslation }, 'Save')
        )
      )
    )
  );
}

export default VendorOffers;
